<div [innerHTML]="content" class="px-2 py-1 bg-white border-black text-xs shadow-md">
</div>

